import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import classes from './UserNav.scss'

// Actions
import { orderActions, userActions } from 'redux/actionCreators'

// Helpers
import _get from 'lodash.get'
import _isEqual from 'lodash.isequal'

const mapStateToProps = (state) => ({
  email: _get(state, ['user', 'me', 'email']) || '',
  cartProducts: _get(state, ['order', 'cartProducts']) || [],
  addToCartAttempted: _get(state, ['order', 'addToCartAttempted']) || false,
  bisProducts: _get(state, 'product.bisProducts') || []
})
const mapDispatchToProps = (dispatch) => ({
  attemptGetCart: () =>
    dispatch(orderActions.attemptGetCart()),
  attemptLogout: () =>
    dispatch(userActions.attemptLogout())
})

@connect(mapStateToProps, mapDispatchToProps)
class UserNav extends Component {
  static propTypes = {
    cartProducts: PropTypes.array.isRequired
  };
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props)
    this.state = { toggle: false, menuCollapse: true }
  }

  componentDidMount () {
    window.objectFitImages()
    this.props.attemptGetCart()
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.addToCartAttempted && !_isEqual(this.props.cartProducts, nextProps.cartProducts)) {
      if (nextProps.cartProducts.length < this.props.cartProducts.length) {
        this.setState({ cartMessage: 'นำสินค้าออกจากตะกร้า' })
      } else if (nextProps.cartProducts.length > this.props.cartProducts.length) {
        this.setState({ cartMessage: 'เพิ่มสินค้าลงในตะกร้า' })
      } else {
        this.setState({ cartMessage: 'เปลี่ยนแปลงจำนวนของสินค้าในตะกร้า' })
      }
      setTimeout(() => this.setState({ cartMessage: '' }), 1500)
    }
    if (_get(nextProps, 'location.pathname') !== _get(this.props, 'location.pathname')) {
      this.setState({ menuCollapse: true })
    }
  }

  _onSearch = () => this.context.router.push('/products');
  _onProfileClick = () => this.setState({ toggle: !this.state.toggle })
  _onCartClick = () => this.context.router.push('/cart');

  _onMenuToggle = () =>
    this.setState({ menuCollapse: !this.state.menuCollapse })

  render () {
    const { cartProducts, email, attemptLogout } = this.props
    return (
      <div>
        <div className='hero'>
          <Link to='/'>
            <img className='logo' src='/images/logo.png' alt='logo-dev' />
          </Link>
          <div className='underline' />
        </div>
        <div className={classes.navBar}>
          <div className={classes.menus}>
            <Link to={`/${this.props.location.search}`} activeClassName={classes.active}>หน้าหลัก</Link>
            <Link to={`/products${this.props.location.search}`} activeClassName={classes.active}>สินค้า</Link>
            <Link to={`/price-table${this.props.location.search}`} activeClassName={classes.active}>ตารางราคา</Link>
            {Boolean((this.props.bisProducts || []).length) && (
              <Link to={`/home-products/back-in-stock${this.props.location.search}`} activeClassName={classes.active}>
                <div className={classes.backInStock}>
                  Back in Stock
                </div>
              </Link>
            )}
            <Link to={`/cart${this.props.location.search}`} activeClassName={classes.active}>ตะกร้าสินค้า</Link>
            <Link to={`/wishlist${this.props.location.search}`} activeClassName={classes.active}>
              <div className={classes.wishlist}>
                <img style={{ marginRight: 5 }} width='23' height='20' src='/images/icon-heart.png' alt='heart' />
                <span>WISH LIST</span>
              </div>
            </Link>
            <Link to={`/contact-us${this.props.location.search}`} activeClassName={classes.active}>ติดต่อเรา</Link>
            <Link to={`/profile${this.props.location.search}`} activeClassName={classes.active}>ประวัติการสั่งซื้อ</Link>
            <Link to={`/payment${this.props.location.search}`} activeClassName={classes.active}>แจ้งการโอนเงิน</Link>
          </div>
          <div className='underline' />
        </div>
        <div className={classes.desktopInfoContainer}>
          <img className={classes.info} src='/images/info.png' width='243' height='54' alt='info' />
          <div>
            <img className={classes.btnSearch} onClick={this._onSearch} src='/images/icon-search.png' width='33' height='33' alt='search' />
            <div className={classes.profileContainer}>
              <img className={classes.btnProfile} onClick={this._onProfileClick} src='/images/icon-profile.png' width='33' height='33' alt='profile' />
              {this.state.toggle && (
                <div className={classes.bubble}>
                  <div className={`${classes.arrowBox} ${classes.profile}`}>
                    <div className={classes.email}>{email}</div>
                    <div className={classes.logout} onClick={this.props.attemptLogout}>
                      <span>ออกจากระบบ</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className={classes.btnCartContainer}>
              <div className={classes.btnCart} onClick={this._onCartClick}>
                <img src='/images/icon-cart.png' width='17' height='16' alt='cart' />
                <span> {cartProducts.length} สินค้าในตะกร้า</span>
              </div>
              <div className={classes.bubble}>
                <div className={`${classes.arrowBox} ${classes.cart} ${this.state.cartMessage && classes.active}`}>
                  <div>{this.state.cartMessage}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.mobileInfoContainer}>
          <div className={classes.btnMenu} onClick={this._onMenuToggle}>
            <img src='/images/icon-menu.png' width='30' height='30' alt='menu' />
          </div>
          <img className={classes.btnSearch} onClick={this._onSearch} src='/images/icon-search.png' width='33' height='33' alt='search' />
          <div className={classes.btnCartContainer}>
            <div className={classes.btnCart} onClick={this._onCartClick}>
              <img src='/images/icon-cart.png' width='17' height='16' alt='cart' />
            </div>
            <div className={`${classes.badge} ${this.state.cartMessage && classes.active}`}>{cartProducts.length}</div>
          </div>
          <div className={classes.mobileMenus} style={{ top: this.state.menuCollapse ? '-100vh' : '0px' }}>
            <div className={classes.menusHeader}>
              <span>MENU</span>
              <div className={classes.btnUp} onClick={this._onMenuToggle}>
                <img src='/images/icon-arrow-up.png' width='24' height='21' alt='menu' />
              </div>
            </div>
            <Link to='/' activeClassName={classes.active}>หน้าหลัก</Link>
            <Link to='/products' activeClassName={classes.active}>สินค้า</Link>
            <Link to='/price-table' activeClassName={classes.active}>ตารางราคา</Link>
            {Boolean((this.props.bisProducts || []).length) && <Link to='/home-products/back-in-stock' activeClassName={classes.active}>Back in Stock</Link>}
            <Link to='/cart' activeClassName={classes.active}>ตะกร้าสินค้า</Link>
            <Link to='/wishlist' activeClassName={`${classes.wishlist} ${classes.active}`}>WISH LIST</Link>
            <Link to='/contact-us' activeClassName={classes.active}>ติดต่อเรา</Link>
            <Link to='/profile' activeClassName={classes.active}>ประวัติการสั่งซื้อ</Link>
            <Link to='/payment' activeClassName={classes.active}>แจ้งการโอนเงิน</Link>
            <a onClick={attemptLogout}>ออกจากระบบ</a>
          </div>
        </div>
        <div className={`${classes.feedback} ${this.state.cartMessage && classes.visible}`}>
          <div>{this.state.cartMessage}</div>
        </div>
        <div className={classes.body}>{this.props.children}</div>
      </div>
    )
  }
}

export default UserNav



// WEBPACK FOOTER //
// ./src/containers/User/UserNav.js